import { ReloadIcon } from "../../icons/ReloadIcon";
import { withBaseButton } from "./BaseButton";

const ReloadButton = withBaseButton(ReloadIcon);

export { ReloadButton };
